/**
 * Sanitize the LEGACY raw-HTML branding fields
 * (customizations.footerHTML / headerHTML) before they are injected into the
 * public layout.
 *
 * This WRAPS the shared allowlist sanitizer rather than carrying its own rules.
 * It used to be a second denylist with the same two holes the rich-text one
 * had — ` on\w+=` misses `<img/onerror=...>` because "/" is not whitespace,
 * and matching the literal string `javascript:` misses `javascript&#58;`,
 * which the browser decodes anyway. These fields render in
 * app/(public)/layout.tsx, i.e. on EVERY storefront page, so a stored payload
 * here would have run site-wide.
 *
 * Two sanitizers meant two sets of bugs. There is now one.
 */
import { sanitizeRichText } from '@/lib/sanitize-rich-text'

export function sanitizeBrandingHtml(html: string | null | undefined): string {
  if (!html || typeof html !== 'string') return ''
  return sanitizeRichText(html)
}
